import React from "react";

const DashboardFooter = () => {
  return (
    <div className="dashboard-footer-wrapper">
      <p>
        <span style={{ fontWeight: "bold" }}>©2022-2022 Warung</span>
        <span style={{ color: "#FF793F", fontWeight: "bold" }}>Acil</span>. All
        Rights Reserved.
      </p>
    </div>
  );
};

export default DashboardFooter;
